import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { Box, Link, Typography } from '@mui/material';
import { DisclosureTooltip } from '@repo/ui/DisclosureTooltip';
import React from 'react';

interface ApyDriverProps {
  termLength: string;
  termLengthValue: string;
  valueTooltip?: string;
  /** Paid summary table: omit redundant "APY" before the rate when the column header is APY. */
  suppressApyTermPrefix?: boolean;
}

const ApyDriver = ({
  termLength,
  termLengthValue,
  valueTooltip,
  suppressApyTermPrefix = false,
}: ApyDriverProps): React.JSX.Element => {
  const showValueOnly = suppressApyTermPrefix && termLength === 'APY';
  const driverValue = showValueOnly ? termLengthValue : `${termLength} ${termLengthValue}`;
  return (
    <Box sx={{ display: 'inline', alignItems: 'center' }}>
      <Typography sx={{ whiteSpace: 'normal', display: 'inline' }}>{driverValue}</Typography>
      <Box component="span" sx={{ display: 'inline', whiteSpace: 'nowrap', verticalAlign: 'top' }}>
        &nbsp;
        {valueTooltip && (
          <DisclosureTooltip
            trigger={
              <Link
                aria-label={`${termLength} info`}
                component="button"
                color="text.primary"
                sx={{ display: 'inline-flex', verticalAlign: 'middle', whiteSpace: 'nowrap' }}
              >
                <HelpOutlineIcon />
              </Link>
            }
          >
            <Typography variant="textSmall">{valueTooltip}</Typography>
          </DisclosureTooltip>
        )}
      </Box>
    </Box>
  );
};

export default ApyDriver;
